import { useContext, useMemo } from 'react';
import AuthContext from '../../auth/context/AuthContext';
import {
  getCurrentClinicTimeFormatFromSession,
  getCurrentClinicTimeFormatFromUser,
} from '../services/ClinicTimeFormatUtils';

export default function useCurrentClinicTimeFormat() {
  const currentUser = useContext(AuthContext);

  return useMemo(
    () => currentUser
      ? getCurrentClinicTimeFormatFromUser(currentUser)
      : getCurrentClinicTimeFormatFromSession(),
    [currentUser],
  );
}
